import { render, staticRenderFns } from "./collectSeven.vue?vue&type=template&id=e1a63892&scoped=true"
import script from "./collectSeven.vue?vue&type=script&lang=js"
export * from "./collectSeven.vue?vue&type=script&lang=js"
import style0 from "./collectSeven.vue?vue&type=style&index=0&id=e1a63892&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a63892",
  null
  
)

export default component.exports